"use strict";
/*
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: IBM Cognos Analytics
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const react_1 = tslib_1.__importDefault(require("react"));
const carbon_components_react_1 = require("carbon-components-react");
const utils_1 = require("../utils");
const COMPONENT_NAME = 'Switch';
const DISPLAY_NAME = (0, utils_1.getDisplayName)(COMPONENT_NAME);
const DEFAULT_TID = (0, utils_1.getDefaultTid)(COMPONENT_NAME);
const Switch = react_1.default.forwardRef((props, ref) => {
    const { 
    // remove - remapped and local props
    'data-tid': dataTid } = props, 
    // pass all other props to Carbon
    otherCarbonProps = tslib_1.__rest(props, ['data-tid']);
    const mappedProps = {
        'data-tid': dataTid !== null && dataTid !== void 0 ? dataTid : DEFAULT_TID,
    };
    if (ref) {
        mappedProps.ref = ref;
    }
    return react_1.default.createElement(carbon_components_react_1.Switch, Object.assign({}, otherCarbonProps, mappedProps));
});
Switch.propTypes = {
    'data-tid': prop_types_1.default.string,
};
Switch.displayName = DISPLAY_NAME;
exports.default = Switch;
